<template>
  <v-dialog
    max-width="503"
    v-model="open"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card>
      <v-card-text class="text-start px-6 py-4">
        <p class="h6 ma-0">
          {{ title }}
        </p>
        <p class="body-1 mt-6 mb-4">
          {{ getReason }}
        </p>
        <div v-if="changedBy" class="d-flex flex-column">
          <FieldLabel :text="titleChangedBy" class="mb-1" />
          <ChipAvatar small :account="changedBy" />
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end px-6 py-4">
        <Button
          slot="modal-footer"
          color="primary"
          data-testid="ChangedStateDetailModal-button-close"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
import { utils } from 'frontend-js-shared'
import ChipAvatar from '@/components/ChipAvatar.vue'
import FieldLabel from '@/components/Core/FieldLabel'
const ENTITIES = { rev: 'Rev', finding: 'Finding' }

export default {
  name: 'ChangedStateDetailModal',

  components: {
    Button,
    ChipAvatar,
    FieldLabel,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
    },
    entity: { String },
  },

  data() {
    return {
      ENTITIES,
    }
  },

  methods: {
    formatStatusDate(date) {
      if (!date) return
      return utils.dates.formatDate(date, 'MMM D, YYYY')
    },
  },
  computed: {
    status() {
      return this.data?.status ?? ''
    },

    canceledStatus() {
      if (this.entity == this.ENTITIES.rev)
        return this.$constants.revStatus.canceled
      return this.$constants.findings.status.canceled
    },

    title() {
      if (this.status === this.canceledStatus)
        return this.$t('common.entity_canceled', {
          entity: this.entity,
        })
      return this.$t('common.entity_onHold', { entity: this.entity })
    },
    subtitle() {
      if (this.status === this.canceledStatus) return this.$t('common.canceled')
      return this.$t('common.on_hold')
    },

    changedBy() {
      if (this.status === this.canceledStatus)
        return this.data?.canceledBy ?? {}
      return this.data?.onHoldBy ?? {}
    },
    titleChangedBy() {
      if (this.status === this.canceledStatus)
        return this.$t('common.canceled_date', {
          date: this.changedAt,
          entity: `${this.entity} ${this.subtitle}`,
        })
      return this.$t('common.onHold_date', {
        status: this.subtitle,
        date: this.changedAt,
        entity: this.entity,
      })
    },
    changedAt() {
      if (this.status === this.canceledStatus)
        return this.formatStatusDate(this.data?.canceledAt) ?? null
      return this.formatStatusDate(this.data?.onHoldAt) ?? null
    },

    getReason() {
      if (this.status === this.canceledStatus)
        return this.data?.canceledReason ?? null
      return this.data?.onHoldReason ?? null
    },
  },
}
</script>
